import { render } from "./SpaDayGuests.vue?vue&type=template&id=1ded31bb"
import script from "./SpaDayGuests.vue?vue&type=script&lang=js"
export * from "./SpaDayGuests.vue?vue&type=script&lang=js"

import "@/shared/css/guests.css?vue&type=style&index=0&lang=css&external"
import "./SpaDayGuests.vue?vue&type=style&index=1&id=1ded31bb&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__